import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';


const DropdownMenu = ({ doc, changestatus }) => {
   
  const selectData = [
    { backgroundColor:'#070d59', color:'white', txt:'Select', disabled: true },
    { backgroundColor:'#76D773', color:'white', txt:'Have This', disabled: false },
    { backgroundColor:'#FFBF00', color:'white', txt:'Working on it', disabled: false },
    { backgroundColor:'#EC5353', color:'white', txt:"Don't Have", disabled: false },
    { backgroundColor:'#848484', color:'white', txt:'N/A', disabled: false }
  ];

  const [select ,setSelect] = useState(doc.gap_status ? selectData[doc.gap_status].txt : selectData[0].txt)
  const [color , setColor] = useState(doc.gap_status ? selectData[doc.gap_status].backgroundColor : selectData[0].backgroundColor)

  

  return (
    <Dropdown>
      <Dropdown.Toggle variant="success" style={{ backgroundColor: color, color: 'white', borderColor:color }} id="dropdown-basic">
        {select}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {selectData.map((item, index) => (
          <Dropdown.Item
            key={index}
            style={{ backgroundColor: item.backgroundColor, color: item.color }}
            onClick={() => {changestatus(doc.id, index); setSelect(item.txt); setColor(item.backgroundColor)}}
            disabled={item.disabled}
          >
            {item.txt}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownMenu;
